<template>
  <section
    class="testifying-to-god-incarnate-wrap"
    v-parallax
    :key="$route.name"
  >
    <v-page
      :background="[
        'images/God-incarnate-and-man-used-by-God/index/God-incarnate-and-man-used-by-God-bg-preload.jpg',
        'images/God-incarnate-and-man-used-by-God/index/front.png',
      ]"
      v-parallax-background
      v-skip="$route.name"
    >
      <v-chapter-title
        :chapTip="firstPageData.episode"
        :chapterTitle="chapterTitle"
        :stageTitle="firstPageData.stage"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-sub-chapter-index-page :pageData="pageDataItem.page0.data" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/God-incarnate-and-man-used-by-God/testifying-to-God-incarnate/page1ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page1.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/God-incarnate-and-man-used-by-God/testifying-to-God-incarnate/page2ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page2.data"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-float-image-content :data="pageDataItem.page3.data.content" />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page4.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-text-content :html="pageDataItem.page5.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/God-incarnate-and-man-used-by-God/testifying-to-God-incarnate/page5ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page6.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/God-incarnate-and-man-used-by-God/testifying-to-God-incarnate/page4ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page7.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/God-incarnate-and-man-used-by-God/testifying-to-God-incarnate/page6ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page8.data"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-text-content :html="pageDataItem.page9.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/God-incarnate-and-man-used-by-God/testifying-to-God-incarnate/page9ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page10.data"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-float-image-content :data="pageDataItem.page11.data.content" />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-picture-wall :data="pageDataItem.page12.data" />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-full-screen-songs-player
        :data="pageDataItem.page13.data"
        bg="images/common/hymnsPosters/God-incarnate-and-man-used-by-God.jpg"
      />
    </v-page>

    <v-page :background="theme.colors.earth">
      <v-chatper-entry bg-color="earth" />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {
      pageDataItem: {},
      chapterTitle: "",
    };
  },
  methods: {
    onCurrentUpdate(current) {
      this.current = current;
    },
  },
  created() {
    this.chapterTitle = this.schema[
      this.get_router_name()
    ].item.index.data.chapterTitle;
    this.firstPageData = this.schema.global.item.aside.data[5];
    this.pageDataItem = this.schema[this.get_router_name()].item;
  },
};
</script>
